export const storeCrewRateList = (state, crewRateList) => {
  state.crewRateList = [...crewRateList];
};
